var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2573",
    "data-name": "Groupe 2573",
    transform: "translate(-1689 -586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CircleWavyWarning",
    transform: "translate(1692 589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_5",
    "data-name": "Soustraction 5",
    d: "M-14747.246-5677.5a3.389,3.389,0,0,1-2.226-1.244l-.028-.027a3.765,3.765,0,0,0-.954-.751,3.742,3.742,0,0,0-1.214-.137,3.353,3.353,0,0,1-2.475-.7,3.407,3.407,0,0,1-.7-2.5l0-.1a3.394,3.394,0,0,0-.132-1.09,3.76,3.76,0,0,0-.756-.952l-.011-.011a3.421,3.421,0,0,1-1.256-2.241,3.369,3.369,0,0,1,1.249-2.226l.012-.012a4.032,4.032,0,0,0,.77-.969,3.89,3.89,0,0,0,.129-1.215v-.04a3.3,3.3,0,0,1,.7-2.431,3.4,3.4,0,0,1,2.508-.708,3.7,3.7,0,0,0,1.181-.129,3.828,3.828,0,0,0,.952-.759,3.436,3.436,0,0,1,2.256-1.263,3.346,3.346,0,0,1,2.207,1.23l.015.014,0,0a4.131,4.131,0,0,0,.977.776,3.876,3.876,0,0,0,1.213.133h.012a3.326,3.326,0,0,1,2.464.7,3.392,3.392,0,0,1,.708,2.5,3.67,3.67,0,0,0,.129,1.188,3.74,3.74,0,0,0,.735.925l.028.03a3.464,3.464,0,0,1,1.255,2.248,3.365,3.365,0,0,1-1.223,2.208l-.018.019a3.837,3.837,0,0,0-.778.981,3.411,3.411,0,0,0-.139,1.119l0,.1a3.3,3.3,0,0,1-.7,2.47,3.379,3.379,0,0,1-2.5.707h-.009a3.793,3.793,0,0,0-1.181.13,3.984,3.984,0,0,0-.948.759l-.015.015A3.424,3.424,0,0,1-14747.246-5677.5Zm-1.248-10.273,0,0,2.623,3.938a.75.75,0,0,0,.623.333.763.763,0,0,0,.218-.034.748.748,0,0,0,.533-.718v-6a.751.751,0,0,0-.751-.749.749.749,0,0,0-.748.749v3.525l-2.626-3.94a.753.753,0,0,0-.623-.334.755.755,0,0,0-.222.034.747.747,0,0,0-.529.715v6a.751.751,0,0,0,.748.752.753.753,0,0,0,.752-.752v-3.522Z",
    transform: "translate(14756.248 5696.249)",
    fill: "#fcc02d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2352",
    "data-name": "Rectangle 2352",
    width: 24,
    height: 24,
    transform: "translate(1689 586)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNew);
export default __webpack_public_path__ + "static/media/status-new.945555454fbfa923badd68f4ab36445d.svg";
export { ForwardRef as ReactComponent };